<script>
    import StartScan from "./top-banner/StartScan.svelte";
    import { Constans } from "../lib/Constants";
    import {navigateTo} from "svelte-router-spa";
    import CleaningSetup from "./top-banner/CleaningSetup.svelte";
    import IosToggle from "./IosToggle.svelte";
    import ScanInProgress from "./top-banner/ScanInProgress.svelte";
    import {Circle} from "svelte-loading-spinners";
    import CleaningPaused from "./top-banner/CleaningPaused.svelte";
    import CleaningStarted from "./top-banner/CleaningStarted.svelte";
    import {onMount} from "svelte";
    import { t, locale, locales } from "../../scripts/i18n";

    onMount(() => {
        window.scrollTo(0, 0);
    });

    export let params = {};

    let curYear = (new Date()).getFullYear();

    let username = null;
    $: params && (username = params.stage ? params.stage.account.username : null);

    let avatar = null;
    $: params && (avatar = params.stage ? params.stage.account.avatar : null);

    let follows = 0;
    $: params && (follows = params.stage ? params.stage.account.follows : 0);

    let followers = 0;
    $: params && (followers = params.stage ? params.stage.account.followers : 0);

    let scanProgress = 0;
    $: params && params.stage && (scanProgress = params.stage.status !== Constans.ANALYZE_STARTED ? 100 : params.stage.analyzeStats.scanProgress);

    let totalThreats = 0;
    $: params && params.stage &&
    (totalThreats = params.stage.status !== Constans.ANALYZE_STARTED ? 2014 :
        params.stage.analyzeStats.botsFound +
        params.stage.analyzeStats.commercialsFound +
        params.stage.analyzeStats.nonReciprocalFound +
        params.stage.analyzeStats.inactiveFound +
        params.stage.analyzeStats.foreignersFound +
        params.stage.analyzeStats.unattainableFound
    );

    let cleanProgress = 0;
    $: params && params.stage && (cleanProgress = params.stage.cleanupStats.cleanProgress);

    let totalCleaned = 0;
    $: params && params.stage && (totalCleaned = params.stage.cleanupStats.threadsRemoved);

    let isStarting = false;

    let guardIsActive = true;
    $: params && params.stage && (guardIsActive = params.stage.guard.isActive);
    let spamProtection = (params && params.stage) ? params.stage.guard.filterSubscribers : true;
    //$: params && params.stage && (spamProtection = params.stage.guard.filterSubscribers);
    $: (spamProtection || !spamProtection) && updateState();
    let commentsProtection = (params && params.stage) ? params.stage.guard.filterComments : true;
    //$: params && params.stage && (commentsProtection = params.stage.guard.filterComments);
    $: (commentsProtection || !commentsProtection) && updateState();
    let spamTagProtection = (params && params.stage) ? params.stage.guard.filterSpamMarks : true;
    //$: params && params.stage && (spamTagProtection = params.stage.guard.filterSpamMarks);
    $: (spamTagProtection || !spamTagProtection) && updateState();
    let spamDirectProtection = (params && params.stage) ? params.stage.guard.filterDirectRequests : true;
    //$: params && params.stage && (spamDirectProtection = params.stage.guard.filterDirectRequests);
    $: (spamDirectProtection || !spamDirectProtection) && updateState();

    function updateState() {
        params.setStage({
            guard: {
                isActive: guardIsActive,
                filterSubscribers: spamProtection,
                filterComments: commentsProtection,
                filterSpamMarks: spamTagProtection,
                filterDirectRequests: spamDirectProtection,
            }
        });
    }

    function startAnalyze(event) {
        isStarting = true;

        setTimeout(() => {
            isStarting = false;
            params.setStage({
                status: Constans.ANALYZE_STARTED,
                analyzeStats: {
                    scanProgress: 0,
                    botsFound: 0,
                    commercialsFound: 0,
                    foreignersFound: 0,
                    inactiveFound: 0,
                    nonReciprocalFound: 0,
                    unattainableFound: 0,
                    followersScanned: 0,
                    followingsScanned: 0,
                },
                cleanupStats: {
                    cleanProgress: 0,
                    threadsRemoved: 0,
                },
            });
            navigateTo('/demo/analyze-in-progress');
        }, 1000);
    }

    function showLoader() {
        if (window.language === 'ru-RU') {
            document.getElementById('account-add-icon').style.display = 'none';
            document.getElementById('account-add-loader').style.display = 'block';
        }
    }

    function showModal(modalId) {
        try {
            MicroModal.show(modalId, {
                onShow: modal => {},
                onClose: modal => {
                    document.dispatchEvent(new CustomEvent("closedModal", {
                        detail: {
                            id: modal.id,
                        },
                    }))
                },
                //openTrigger: 'data-custom-open',
                //closeTrigger: 'data-custom-close',
                openClass: 'is-open',
                //disableScroll: true,
                //disableFocus: false,
                //awaitOpenAnimation: false,
                //awaitCloseAnimation: false,
                //debugMode: true,
            });
        } catch (err) {
            console.error(err);
        }
    }

    function addAccount(event) {
        if (window.language === 'en-US') {
            window.location.href = '/signup';
            return;
        }

        userAutoRegister();
    }
</script>

<div class="index-wrap position-relative">
    <div class="banner-top">
        {#if params.stage.status === Constans.CLEANING_COMPLETE}
            <StartScan stage={params.stage} setStage={params.setStage} startAnalyze={startAnalyze}/>
        {/if}
        {#if params.stage.status === Constans.ANALYZE_FINISHED}
            <CleaningSetup stage={params.stage} setStage={params.setStage} />
        {/if}
        {#if params.stage.status === Constans.ANALYZE_STARTED}
            <ScanInProgress stage={params.stage} setStage={params.setStage} />
        {/if}
        {#if params.stage.status === Constans.CLEANING_PAUSED}
            <CleaningPaused stage={params.stage} setStage={params.setStage} />
        {/if}
        {#if params.stage.status === Constans.CLEANING_STARTED}
            <CleaningStarted stage={params.stage} setStage={params.setStage} />
        {/if}
    </div>

    <div class="accounts-selector-wrap mb-20px">
        <div class="inner-wrap mx-auto">
            <div class="left-arrow-wrap hide">
                <img src="/static/media/bx_bx-chevron-left.6d5444a0.svg" alt="/" class="">
            </div>
            <div class="account-info-wrap mx-auto">
                <div class="avatar-wrap mr-20px">
                    <img src={avatar} alt="avatar" class="item-photo media-object" />
                </div>
                <div class="info-wrap mb-20px">
                    <div class="username-wrap">
                        @{$t("photographer.london")}
                    </div>
                    <div class="stats-wrap">
                        <span>{follows} {$t("followings")}</span>
                        <span>{followers} {$t("followers")}</span>
                    </div>
                </div>
                <div class="controls-wrap">
                    <a href="#" on:click={() => showModal('account-settings')} class="account-settings-btn mr-20px">
                        <img src="/static/media/feather_settings.8f3ec50d.svg" alt="/" >
                    </a>
                    <div class="account-add-btn-wrap">
                        <a href="/signup"
                           on:click|preventDefault={addAccount}
                           class="btn item-content-add-btn auto-reg-spamguard.bak"
                           id="add-account-ru-demo-btn.bak"
                        >
                            <img src="https://bot-removal.com/static/media/bx_bx-plus.96be2ac0.svg" alt="/" id="account-add-icon" title="{$t('Add account')}">
                            {#if false}
                                <img class="loading-ico" id="account-add-loader" src="/img/landing/main-square.gif" style="width: 35px; margin: auto; display: none" alt="loading"/>
                            {/if}
                        </a>
                    </div>
                </div>
            </div>
            <div class="right-arrow-wrap hide">
                <img src="/static/media/bx_bx-chevron-right.3ab65077.svg" alt="/" class="">
            </div>
        </div>
    </div>


    <div class="service-options-wrap mx-auto">
        <div class="scan-and-clean-option-wrap mb-20px">
            <div class="option-wrap">
                <div class="icon-wrap">
                    <img src="/static/media/bx_bx-target-lock.b1504136.svg" alt="/" class="block-services-div-top-img" />
                </div>
                <div class="title-wrap">{$t("Scan and cleaning")}</div>
                <div class="inner-wrap">
                    <div class="sub-title-wrap scans-left-wrap">{$t("Scans left")}: 3</div>
                    <div class="scan-stats mb-20px">
                        <div class="stat-item">
                            <div class="stat-description">
                                {$t("Scan progress")}
                            </div>
                            <div class="stat-value">
                                <span>{scanProgress}%</span>
                            </div>
                        </div>
                        <div class="stat-item">
                            <div class="stat-description">
                                {$t("Unwanted accounts detected")}
                            </div>
                            <div class="stat-value">
                                <span>{totalThreats}</span>
                            </div>
                        </div>
                        <div class="stat-item">
                            <div class="stat-description">
                                {$t("Cleaning progress")}
                            </div>
                            <div class="stat-value">
                                <span>{cleanProgress}%</span>
                            </div>
                        </div>
                        <div class="stat-item">
                            <div class="stat-description">
                                {$t("Unwanted accounts removed")}
                            </div>
                            <div class="stat-value">
                                <span>{totalCleaned}</span>
                            </div>
                        </div>
                    </div>


                    <div class="controls-wrap">
                        {#if params.stage && params.stage.status === Constans.CLEANING_COMPLETE}
                            <a href="#" on:click={startAnalyze} class="pulse-button purple-btn purple-btn_hover w-210px h-45px">
                                {$t("Scan")}
                                {#if isStarting}
                                    <span class="ml-10px">
                                        <Circle size="19" color="#FFF" unit="px" duration="1s" />
                                    </span>
                                {/if}
                            </a>
                        {/if}

                        {#if params.stage && params.stage.status === Constans.ANALYZE_STARTED}
                            <a href="/demo/analyze-in-progress" class="purple-btn purple-btn_hover w-210px h-45px">
                                {$t('Scan progress')}
                            </a>
                        {/if}

                        {#if params.stage && [Constans.ANALYZE_FINISHED].includes(params.stage.status)}
                            <a href="/demo/analyze-finished" class="pulse-button purple-btn purple-btn_hover w-210px h-45px">
                                {$t('Cleaning settings')}
                            </a>
                        {/if}

                        {#if params.stage && [Constans.CLEANING_PAUSED, Constans.CLEANING_STARTED].includes(params.stage.status)}
                            <a href="/demo/analyze-finished" class="purple-btn purple-btn_hover w-210px h-45px">
                                {$t('Cleaning progress')}
                            </a>
                        {/if}
                    </div>

                </div>
            </div>
        </div>
        <div class="guard-option-wrap mb-20px">
            <div class="option-wrap">
                <div class="icon-wrap">
                    <img src="/static/media/mdi_shield-refresh-outline.2304e7cb.svg" alt="/" class="block-services-div-top-img" />
                </div>
                <div class="title-wrap">{$t("Real-time protection")}</div>
                <div class="inner-wrap">
                    {#if guardIsActive}
                        <div class="sub-title-wrap guard-status-wrap">{$t("Your account is protected")}</div>
                    {:else}
                        <div class="danger sub-title-wrap guard-status-wrap">{$t('The protection is not active')}</div>
                    {/if}
                    <div class="guard-options-wrap mb-20px">
                        <div class="stat-item">
                            <IosToggle
                                    label="{$t('Protection against spam followers')}"
                                    bind:checked={spamProtection}
                                    disabled={false}
                                    showTooltip={false}
                                    tooltipTitle={null}
                                    tooltipContent=""
                                    backgroundColor="#8001BD"
                                    widgetClass="w-100pc"
                            />
                        </div>
                        <div class="stat-item">
                            <IosToggle
                                    label="{$t('Comments protection')}"
                                    bind:checked={commentsProtection}
                                    disabled={false}
                                    showTooltip={false}
                                    tooltipTitle={null}
                                    tooltipContent=""
                                    backgroundColor="#8001BD"
                                    widgetClass="w-100pc"
                            />
                        </div>
                        <div class="stat-item">
                            <IosToggle
                                    label="{$t('Protection against spam tag in photo')}"
                                    bind:checked={spamTagProtection}
                                    disabled={false}
                                    showTooltip={false}
                                    tooltipTitle={null}
                                    tooltipContent=""
                                    backgroundColor="#8001BD"
                                    widgetClass="w-100pc"
                            />
                        </div>
                        <div class="stat-item">
                            <IosToggle
                                    label="{$t('Protection against spam direct requests')}"
                                    bind:checked={spamDirectProtection}
                                    disabled={false}
                                    showTooltip={false}
                                    tooltipTitle={null}
                                    tooltipContent=""
                                    backgroundColor="#8001BD"
                                    widgetClass="w-100pc"
                            />
                        </div>
                    </div>

                    <div class="controls-wrap">
                        <a href="/demo/protection-settings" class="purple-btn purple-btn_hover w-210px h-45px">
                            {$t('Protection settings')}
                        </a>
                    </div>
                </div>
            </div>
        </div>
        <div class="guard-report-wrap mb-20px">
            <div class="option-wrap">
                <div class="icon-wrap">
                    <img src="/static/media/ant-design_history-outlined.5d8b662a.svg" alt="/" class="block-services-div-top-img" />
                </div>
                <div class="title-wrap">{$t('Protection report')}</div>
                <div class="inner-wrap">
                    <div class="sub-title-wrap guard-status-wrap">{$t('Protection available until')} {window.language === 'ru-RU' ? '31-12-' + curYear : curYear + '-12-31'}</div>
                    <div class="stats-wrap mb-20px">
                        <div class="stat-item">
                            <div class="stat-description">
                                {$t('Followers removed')}
                            </div>
                            <div class="stat-value">
                                <span>41</span>
                            </div>
                        </div>
                        <div class="stat-item">
                            <div class="stat-description">
                                {$t('Comments removed')}
                            </div>
                            <div class="stat-value">
                                <span>17</span>
                            </div>
                        </div>
                        <div class="stat-item">
                            <div class="stat-description">
                                {$t('Tags in photo removed')}
                            </div>
                            <div class="stat-value">
                                <span>15</span>
                            </div>
                        </div>
                        <div class="stat-item">
                            <div class="stat-description">
                                {$t('Direct requests removed')}
                            </div>
                            <div class="stat-value">
                                <span>23</span>
                            </div>
                        </div>
                    </div>
                    <div class="controls-wrap">
                        <a href="/demo/protection-report" class="link">{$t('Full report')}</a>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>


<style>
    @media (max-device-width: 480px) {
        .account-info-wrap {
            flex-direction: column;
        }
        .service-options-wrap {
            flex-direction: column;
        }
    }

    .guard-report-wrap .link {
        color: indigo;
        text-decoration: underline;
        border-radius: 0;
        font-family: Roboto;
        font-style: normal;
        font-weight: 400;
        font-size: 16px;
        line-height: 19px;
        transition: all 1s ease;
        padding: 13px 0;
    }

    .option-wrap {
        background: #fff;
        border: 0.5px solid #8a8585;
        box-sizing: border-box;
        box-shadow: 0 4px 10px rgba(0,0,0,.25);
        border-radius: 21px;
        text-align: center;
        min-height: 420px;
        min-width: 355px;
    }

    .option-wrap .title-wrap {
        font-family: Roboto;
        font-style: normal;
        font-weight: 400;
        font-size: 20px;
        line-height: 23px;
        text-align: center;
        margin-bottom: 18px;
        color: #000;
    }

    .inner-wrap {
        padding: 0 20px;
    }

    .inner-wrap .sub-title-wrap {
        color: #4caf50;
        font-family: Roboto;
        font-style: normal;
        font-weight: 400;
        font-size: 14px;
        line-height: 16px;
        text-align: center;
        margin-bottom: 0;
        margin-top: 18px;
    }
    .inner-wrap .stat-item {
        font-family: Roboto;
        font-style: normal;
        color: #000;
        text-align: left;
        font-weight: 300;
    }
    .inner-wrap .stat-description {
        font-size: 14px;
    }

    .danger {
        color: red!important;
    }

    .service-options-wrap {
        display: flex;
        width: 100%;
        max-width: 1140px;
        justify-content: space-between;
        align-items: center;
        padding: 10px;
    }

    .controls-wrap {
        display: flex;
        justify-content: center;
        align-items: center;
    }
    .account-add-btn-wrap {
        border-left: 1px solid #8a8585;
        padding-left: 20px;
    }

    .item-content-add-btn {
        background: #fff;
        border: 2px solid indigo;
        box-sizing: border-box;
        box-shadow: 0 4px 4px rgba(0,0,0,.25);
        height: 55px;
        width: 55px;
        border-radius: 50%;
        padding: 8px 2px 2px;
        transition: all .5s ease;
    }
    .stats-wrap {
        font-weight: 400;
        font-size: 14px;
        line-height: 16px;
        font-family: Roboto;
        font-style: normal;
        color: #000;
    }
    .username-wrap {
        font-family: Roboto;
        font-style: normal;
        color: #000;
        font-weight: 700;
        font-size: 16px;
        line-height: 19px;
        padding-top: 10px;
        margin-bottom: 11px;
    }
    .account-info-wrap {
        max-width: 500px;
        display: flex;
        justify-content: center;
        align-items: center;
    }
    .account-info-wrap .info-wrap {
        flex-grow: 1;
    }
    .accounts-selector-wrap {
        width: 100%;
        background-color: #fff;
    }
    .accounts-selector-wrap .inner-wrap {
        width: 100%;
        min-height: 125px;
        max-width: 1140px;
        display: flex;
        justify-content: space-between;
        align-items: center;
        padding: 10px;
    }
    .account-info-wrap {
        flex-grow: 1;
    }

</style>